export default __webpack_public_path__ + "static/media/game_02_intro.272eec17.png";